import {ref, reactive} from "vue";

export const hasSubmitted = ref(false);
export const canSubmitForm = ref(false);

export const validAddress = reactive({
    data: undefined
});
export const results = ref({
    data: undefined
});
